import React from "react"
import { navigate } from "gatsby"
import PropTypes from "prop-types"
import { PageHeader } from "@bw/modules"
import { VaudMap } from "@bw/partials"
import usePrefecturesCollection from "../../../hooks/usePrefecturesCollection"

const MapHeader = ({ title }) => {
  const prefectures = usePrefecturesCollection()
  const clickOnMap = React.useCallback(
    e => {
      const prefecture = prefectures.find(
        prefecture => prefecture.district.value === e.target.id
      )

      if (prefecture) {
        navigate(prefecture.url)
      }
    },
    [prefectures]
  )
  return (
    <PageHeader suptitle={<VaudMap onClick={clickOnMap} />} title={title} />
  )
}

MapHeader.propTypes = {
  title: PropTypes.string,
}

export { MapHeader }
